
export interface IYii {
    t: (section: TYiiSection,
        code: string) => string;
    translate: {
        config : {
            language : string;
        }
    };
}

type TYiiSection =
    'wui-shared-js' |
    'wui-iqbh-js' |
    'wui-iqba-js' |
    'wui-skn-js' |
    'wui-sasha-js' |
    'wui-app-js' |
    'wui-home-js' |
    'wui-watabi-js' |
    'wui-quotation-js' |
    'wui-stock-js' |
    'wui-dashboard-js';

declare const Yii: IYii;
const fakeYii = Yii;
export { fakeYii as Yii };
